import { FormEvent, useState } from 'react';
import { Container, Form, Row, Button, Col } from 'react-bootstrap';
import * as SC from './styled';
import api from 'api/api';

interface IFormSubmit {
  name?: string;
  email?: string;
  message?: string;
  phone?: string;
}

interface IFormError {
  nameValid: boolean;
  emailValid: boolean;
  messageValid: boolean;
  phoneValid: boolean;
}

const Contact = () => {
  const [contactSent, setContactSent] = useState<boolean>(false);
  const [formError, setFormError] = useState<IFormError>();
  const [formValue, setFormValue] = useState<IFormSubmit>({
    name: '',
    email: '',
    message: '',
    phone: '',
  });

  const changeField = (e: FormEvent<any>) => {
    const element = e.currentTarget;
    setFormValue({ ...formValue, [element.id]: element.value });
  };

  const checkValidation = (): boolean => {
    const { name, email, message } = formValue;
    const nameValid = name ? name?.length >= 3 : false;
    const emailValid = email ? email.match(/.+@.+/)?.length === 1 : false;
    const messageValid = message ? message.length >= 3 : false;
    const phoneValid = true;

    setFormError({
      nameValid,
      emailValid,
      messageValid,
      phoneValid,
    });

    if (nameValid && emailValid && messageValid) return true;
    else return false;
  };

  const postContactForm = (e: FormEvent<any>) => {
    e.preventDefault();
    const fieldsValid = checkValidation();

    fieldsValid &&
      api.ownapi.post('/contact', formValue).then(() => {
        setContactSent(true);
      });
  };

  return (
    <SC.MessageContainer>
      <Container className="contact-content">
        {!contactSent ? (
          <div className="description">
            <h2>Du hast Fragen?</h2>
            <p>Schreibe uns Eine Nachricht!</p>
          </div>
        ) : (
          <div className="description">
            <h2>Vielen Dank!</h2>
          </div>
        )}
        {!contactSent && (
          <div className="contact-form">
            <Form>
              <Row>
                <Col sm>
                  <Form.Group controlId="name">
                    <Form.Control
                      isValid={formError?.nameValid}
                      isInvalid={
                        formError?.nameValid !== undefined &&
                        !formError?.nameValid
                      }
                      onChange={changeField}
                      placeholder="Name*"
                    />
                  </Form.Group>
                </Col>
                <Col sm>
                  <Form.Group controlId="email">
                    <Form.Control
                      isValid={formError?.emailValid}
                      isInvalid={
                        formError?.emailValid !== undefined &&
                        !formError?.emailValid
                      }
                      onChange={changeField}
                      type="email"
                      placeholder="Email*"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group controlId="message">
                <Form.Control
                  isValid={formError?.messageValid}
                  isInvalid={
                    formError?.messageValid !== undefined &&
                    !formError?.messageValid
                  }
                  as="textarea"
                  placeholder="Deine Nachricht*"
                  rows={5}
                  onChange={changeField}
                />
              </Form.Group>

              <Button variant="primary" onClick={postContactForm} type="submit">
                Absenden
              </Button>
            </Form>
          </div>
        )}
      </Container>
    </SC.MessageContainer>
  );
};

export default Contact;
